<app-tool-loader positionUnset="true" class=" pt-0">
    <div class="flex flex-col space-y-2 pt-0">

        <div class="flex flex-col pt-0">
            <label for="type">Unit Type</label>
            <p-select 
                filter="true"
                #unitTypeDropdown
                [options]="unitTypes" 
                optionLabel="name" 
                appendTo="body" 
                optionValue="value"
                placeholder="Select Unit Type" 
                (onChange)="selectedUnitTypeChange($event, unitTypeDropdown)"
                [(ngModel)]="selectedUnitType">
            </p-select>
        </div>

        <div class="flex space-x-2">
            <div class="flex flex-col w-full">
                <label>From</label>
                <p-input-group>
                    <p-inputNumber 
                        [minFractionDigits]="1" 
                        [(ngModel)]="fromValue"
                        (ngModelChange)="convertUnits()">
                    </p-inputNumber>
                    <p-select 
                        [options]="unitOptions" 
                        optionLabel="name" 
                        optionValue="value" 
                        appendTo="body"
                        [(ngModel)]="fromUnit" 
                        (onChange)="convertUnits()">
                    </p-select>
                </p-input-group>
            </div>

            <div class="flex flex-col w-full">
                <label>To</label>
                <p-input-group>
                    <p-inputNumber [maxFractionDigits]="7" [minFractionDigits]="1" [(ngModel)]="convertedUnit"
                        [disabled]="true"></p-inputNumber>
                    <p-select [options]="unitOptions" optionLabel="name" optionValue="value" appendTo="body"
                        [(ngModel)]="toUnit" (onChange)="convertUnits()"></p-select>
                </p-input-group>
            </div>
        </div>
    </div>
</app-tool-loader>